<template>
  <div class="login-screen">
    <h1 class="title">{{ eventTitle }}</h1>
    <form @submit.prevent="handleLogin">
      <div class="input-group">
        <label for="email">Email</label>
        <input type="email" id="email" v-model="email" required />
      </div>
      <div class="input-group">
        <label for="password">Password</label>
        <input type="password" id="password" v-model="password" required />
      </div>
      <button type="submit" class="login-button">Login</button>
      <div class="input-group">
        <label for="verification-code">Verification Code</label>
        <input
          type="text"
          id="verification-code"
          v-model="verificationCode"
          maxlength="6"
          placeholder="Enter 6-digit code"
          required
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      eventTitle: "Gala Dinner",
      email: "",
      password: "",
      verificationCode: "",
    };
  },
  methods: {
    handleLogin() {
      // Simulate login and navigate to the dashboard
      this.$router.push({ name: "Dashboard" });
    },
  },
};
</script>


<style scoped>
.login-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /*background-color: #001643;*/
  color: white;
  height: 100vh;
  font-family: Arial, sans-serif;
}

.title {
  color: #ff6b35;
  font-size: 2rem;
  margin-bottom: 2rem;
}

.form {
  width: 100%;
  max-width: 400px;
}

.input-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  color: white;
}

label {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

input[type="email"],
input[type="password"],
input[type="text"] {
  padding: 0.5rem;
  font-size: 1rem;
  color: #001643;
}

.login-button {
  background-color: #00cfff;
  color: white;
  border: none;
  padding: 0.7rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  margin-bottom: 1rem;
}

.login-button:hover {
  background-color: #008fb3;
}
</style>
